import type { AccessGrant } from './AccessGrantFields';

/** The request body parts of the two fields (the same shape for boards and databases). */
export function teamAccessBody(grants: readonly AccessGrant[]) {
  return grants.map((g) => ({ team_id: g.id, role: g.role }));
}

export function roleAccessBody(grants: readonly AccessGrant[]) {
  return grants.map((g) =>
    g.id.startsWith('custom:')
      ? { custom_role_id: g.id.slice(7), role: g.role }
      : { subject_role: g.id.slice(5), role: g.role },
  );
}
